const AirlinesTableColumns = [
    {
        id: "logo",
        labelAr: "الشعار",
        labelEn: "Logo",
        sortable: false,
    },
    {
        id: "name_ar",
        labelAr: "الاسم (عربي)",
        labelEn: "Name (AR)",
        sortable: true,
    },
    {
        id: "name_en",
        labelAr: "الاسم (إنجليزي)",
        labelEn: "Name (EN)",
        sortable: true,
    },
    {
        id: "status",
        labelAr: "الحالة",
        labelEn: "Status",
        sortable: true,
    },
];

export default AirlinesTableColumns;
